
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
			//ajax地址
			getAmount: {
				custom: true,
				url: (data:any)=>`/apis/moyin-account/v1/gifts/charge/amount`,
				method: 'get'
			},
			getGiftsList: {
				custom: true,
				url: (data:any)=>`/apis/moyin-account/v1/gifts/list`,
				method: 'get'
			},
			receive: {
				custom: true,
				headers: {
					'content-type': 'application/x-www-form-urlencoded'
				},
				url: (data:any)=>`/apis/moyin-account/v1/gifts/list/receive?giftId=${data.giftId}&&packageIdList=${data.packageIdList}`,
				method: 'post'
			},
			getVoiceList: {
				custom: true,
				headers: {
					'content-type': 'application/x-www-form-urlencoded'
				},
				url: (data:any)=>`/apis/moyin-account/v1/gifts/speaker/select?keyword=${data.keyword}&&pageSize=${data.pageSize}&&pageNum=${data.pageNum}`,
				method: 'post',
			},

		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"exchangeBeanPage"
			})
		}